module.exports = __webpack_public_path__ + "resources/img/mark_27017_lg.be4e2d608a4d11ee9c4c937259ffabe7.png";